import { inject, Injectable } from '@angular/core';
import { Client, FaqDto } from '../../../../api/client';
import { Observable } from 'rxjs';

@Injectable()
export class AuthentithicationService {
  private client = inject(Client);

  getQuestionList(): Observable<FaqDto[]> {
    return this.client.faq_GetAuthFaq();
  }
}
